module.exports = __webpack_public_path__ + "static/media/02-TRAILER_20FT.c92f2fe2.png";